import { render } from "./ApprovePaymentLiquidations.vue?vue&type=template&id=a7868c76"
import script from "./ApprovePaymentLiquidations.vue?vue&type=script&lang=js"
export * from "./ApprovePaymentLiquidations.vue?vue&type=script&lang=js"

import "./ApprovePaymentLiquidations.vue?vue&type=style&index=0&id=a7868c76&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__